import type { LocationsFilters } from '../types';

/**
 * Query key factory for locations feature
 */
export const locationKeys = {
  all: ['locations'] as const,
  lists: () => [...locationKeys.all, 'list'] as const,
  list: (filters: LocationsFilters) => [...locationKeys.lists(), filters] as const,
  details: () => [...locationKeys.all, 'detail'] as const,
  detail: (id: string) => [...locationKeys.details(), id] as const,
  options: (accountId?: string) => [...locationKeys.all, 'options', accountId] as const,
  accounts: () => [...locationKeys.all, 'accounts'] as const,
  accountsInfinite: (search: string) =>
    [...locationKeys.all, 'accounts', 'infinite', search] as const,
  account: (id: string) => [...locationKeys.all, 'accounts', 'detail', id] as const,
  // Form options (usergroups, transmitters, sensors)
  formOptions: (organisationId?: string, locationId?: string) =>
    [...locationKeys.all, 'formOptions', organisationId, locationId] as const,
  // Changelog
  changelogs: () => [...locationKeys.all, 'changelog'] as const,
  changelog: (locationId?: string) => [...locationKeys.changelogs(), locationId] as const,
};
